export const initialState = {
  loadingStatus: {
    addressBookLoading: false,
  },
  error: '',
  addressBook: [],
};
